import * as angular from "angular";

export class CollectionPurposeService {
    private $http: any;
    private readonly apiRoot: string;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/collectionpurpose";
    }

    all(): Promise<object> {
        return this.$http.get(this.apiRoot);
    }

    create(data: object): Promise<object> {
        return this.$http.post(this.apiRoot, data);
    }

    update(dataPoint: any): Promise<object> {
        return this.$http.post(
            this.apiRoot + "/" + dataPoint.dpcpid,
            dataPoint
        );
    }

    points(): Promise<object> {
        return this.$http.get(this.apiRoot + "/points");
    }

    protection(): Promise<object> {
        return this.$http.get(this.apiRoot + "/protection");
    }

    createPurpose(data: object): Promise<object> {
        return this.$http.post(this.apiRoot + "/purpose", data);
    }

    createOfficer(data: object): Promise<object> {
        return this.$http.post(this.apiRoot + "/officer", data);
    }

    updateOfficer(officer: any): Promise<object> {
        return this.$http.post(
            this.apiRoot + "/officer/" + officer.officerid,
            officer
        );
    }
}

angular
    .module("vcServices")
    .service("CollectionPurposeService", CollectionPurposeService);
